import React from "react";
import { IpadTabletSec } from "./ipad";

export const IpadTablet = () => {
  return (
    <React.Fragment>
      <div className="ipad-main">
        <IpadTabletSec />
      </div>
    </React.Fragment>
  );
};
